import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import Button from "@material-ui/core/Button"
import TextField from "@material-ui/core/TextField"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Grid from "@material-ui/core/Grid"
import withStyles from "@material-ui/core/styles/withStyles"

import { updateDevice, updateDeviceDisplay } from "../../actions/deviceActions"
import { getDisplayName } from "../../util/deviceHelpers"
import BasicModalTextButton from "../Common/Modals/BasicModalTextButton"
import { deleteDeviceData } from "../../actions/dataClearingActions"
import { Typography } from "@material-ui/core"

const styles = () => ({
  buttonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  buttons: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
})

const EditDeviceModal = (props) => {
  const { classes, device, open, handleClose } = props
  const allDeviceData = useSelector((state) => state.device.deviceData)

  const [deviceState, setDeviceState] = useState(allDeviceData?.find((d) => d.device_id === device))

  useEffect(() => {
    setDeviceState(allDeviceData.find((d) => d.device_id === device))
  }, [allDeviceData, device])

  const dispatch = useDispatch()

  const handleSave = () => {
    dispatch(updateDevice({ ...deviceState }))
    dispatch(updateDeviceDisplay({ ...deviceState }))
    handleClose()
  }

  const handleRevokeOwnership = async () => {
    await deleteDeviceData(device, { ownership: true })
    window.location.reload()
  }

  const handleArchiveInsights = async () => {
    await deleteDeviceData(device, { insights: true })
    handleClose()
  }

  const handleChange = (key, value) => {
    setDeviceState({
      ...deviceState,
      [key]: value,
    })
  }

  const handleLocationChange = (key, value, min, max) => {
    const parsedValue = parseFloat(value)
    if (!parsedValue || (parsedValue >= min && parsedValue <= max)) {
      handleChange(key, value)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Editing Device: {getDisplayName(deviceState)}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              margin="dense"
              label="Device Name"
              name="device_name"
              inputProps={{
                maxLength: 30,
              }}
              value={deviceState.display_name}
              onChange={(event) => handleChange("display_name", event.currentTarget.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              variant="outlined"
              rows={4}
              inputProps={{
                maxLength: 100,
              }}
              margin="dense"
              label="Device Description"
              name="description"
              value={deviceState.description}
              onChange={(event) => handleChange("description", event.currentTarget.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              margin="dense"
              label="Location Name"
              name="location_name"
              inputProps={{
                maxLength: 30,
              }}
              value={deviceState.location_name}
              onChange={(event) => handleChange("location_name", event.currentTarget.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              multiline
              variant="outlined"
              rows={4}
              inputProps={{
                maxLength: 100,
              }}
              margin="dense"
              label="Location Description"
              name="location_description"
              value={deviceState.location_description}
              onChange={(event) => handleChange("location_description", event.currentTarget.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              inputProps={{
                maxLength: 30,
              }}
              margin="dense"
              label="Latitude"
              name="latitude"
              value={deviceState.latitude}
              onChange={(event) =>
                handleLocationChange("latitude", event.currentTarget.value, -90, 90)
              }
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              inputProps={{
                maxLength: 30,
              }}
              margin="dense"
              label="Longitude"
              name="longitude"
              value={deviceState.longitude}
              onChange={(event) =>
                handleLocationChange("longitude", event.currentTarget.value, -180, 180)
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <div className={classes.buttonContainer}>
          <div className={classes.buttons}>
            <BasicModalTextButton
              confirmText="Revoke"
              title={`Revoke Ownership of Device?`}
              content={
                <Typography>
                  Revoke ownership of this device? Device will no longer show up on this dashboard.
                  You will need to contact sentinel-support to get access to this device again.
                </Typography>
              }
              buttonText="Revoke Ownership"
              buttonColor="secondary"
              fullWidth
              confirmAction={handleRevokeOwnership}
            />
            <BasicModalTextButton
              confirmText="Archive"
              title={`Archive All Insights?`}
              content={
                <Typography>
                  Archive all insights associated with this device? This will take a few minutes to
                  take effect and will require a refresh to show on the dashboard. You will need to
                  contact sentinel-support to get access to these insights again.
                </Typography>
              }
              buttonText="Archive Insights"
              buttonColor="secondary"
              fullWidth
              confirmAction={handleArchiveInsights}
            />
          </div>
          <div className={classes.buttons}>
            <Button color="primary" onClick={handleClose}>
              Cancel
            </Button>
            <Button color="primary" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default withStyles(styles)(EditDeviceModal)
